// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form_main[data-v-77741024]{display:flex;flex-wrap:wrap;align-items:center}.form_main .form_item[data-v-77741024]{display:flex;flex-direction:column;margin-right:20px}.form_main .form_item .form_title[data-v-77741024]{padding:0 10px}.form_main .form_item .form_title[data-v-77741024]:before{content:\"* \";color:red}.form_main .form_item .form_input[data-v-77741024]{width:200px;padding:5px 10px}", ""]);
// Exports
module.exports = exports;
